import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


  
// Inizializzare GSAP e ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// Seleziona tutti gli elementi con la classe .colore-sfondo
gsap.utils.toArray(".colore-sfondo").forEach(function (elem) {
    if (elem.classList.contains('colore-sfondo--head')) {
        const parentElem = elem.parentElement; 

        if (parentElem) {
            const tl = gsap.timeline();

            // Definiamo più fasi dell'animazione
            tl.fromTo(elem, 
                { opacity: 1 }, // stato iniziale
                { opacity: 1, duration: 1 }  // prima fase: fade in
            )
            .to(elem, 
                { opacity: 1, duration: 5 }  // seconda fase: rimane visibile
            )
            .to(elem, 
                { opacity: 0, duration: 5 }  // terza fase: fade out
            );


            ScrollTrigger.create({
                animation: tl,
                trigger: parentElem, // Usa il parent come trigger
                start: 'top top', // Inizia quando l'elemento è appoggiato al top della pagina
                end: 'bottom 0', // Finisce quando l'elemento ha scrollato 100vh
                // start: 'bottom 0', // Inizia quando l'elemento è appoggiato al top della pagina
                // end: 'bottom -300px', // Finisce quando l'elemento ha scrollato 100vh
                scrub: 0.1,
                // markers: true, // Opzionale per il debug
            });
        }
    } else {
        const parentElem = elem.parentElement; 

        if (parentElem) {
            const tl = gsap.timeline();

            // Definiamo più fasi dell'animazione
            tl.fromTo(elem, 
                { opacity: 0 }, // stato iniziale
                { opacity: 1, duration: 1 }  // prima fase: fade in
            )
            .to(elem, 
                { opacity: 1, duration: 2 }  // seconda fase: rimane visibile
            )
            .to(elem, 
                { opacity: 0, duration: 1 }  // terza fase: fade out
            );

            ScrollTrigger.create({
                animation: tl,
                trigger: parentElem,
                // Inizia quando il bottom dell'elemento entra nella viewport
                start: "top 70%",
                // Finisce quando il top dell'elemento sta per uscire dalla viewport
                end: "bottom 30%",

                scrub: true,
                // toggleActions: "play reverse play reverse", // alternativa per controllare il comportamento
                // markers: true, // per debug
            });
        }
    }
});
